const styles = () => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 151px',
    columnGap: '10px',
    marginBottom: '8px',
    alignItems: 'flex-end',
  },
  informationMessage: {
    color: '#6C7281',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: '6px',
  },

  '@media (max-width: 645px)': {
    container: {
      gridTemplateColumns: 'auto 119px',
      columnGap: '6px',
      '& button': {
        height: '51px',
      },
    },
  },
});

export default styles;
